"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function omit(obj, omitKeys) {
    var result = {};
    Object.keys(obj).forEach(function (key) {
        if (omitKeys.indexOf(key) === -1) {
            result[key] = obj[key];
        }
    });
    return result;
}
exports.omit = omit;
function objectPath(str) {
    if (typeof str !== 'string') {
        throw new TypeError('Field name must be passed a string');
    }
    var parts = [];
    var i = 0, d, b, q, c;
    while (i < str.length) {
        d = str.indexOf('.', i);
        b = str.indexOf('[', i);
        // we've reached the end
        if (d === -1 && b === -1) {
            parts.push(str.slice(i, str.length));
            i = str.length;
        }
        // dots
        else if (b === -1 || (d !== -1 && d < b)) {
            parts.push(str.slice(i, d));
            i = d + 1;
        }
        // brackets
        else {
            if (b > i) {
                parts.push(str.slice(i, b));
                i = b;
            }
            q = str.slice(b + 1, b + 2);
            if (q !== '"' && q !== '\'') {
                c = str.indexOf(']', b);
                if (c === -1) {
                    c = str.length;
                }
                parts.push(str.slice(i + 1, c));
                i = (str.slice(c + 1, c + 2) === '.') ? c + 2 : c + 1;
            }
            else {
                c = str.indexOf(q + ']', b);
                if (c === -1) {
                    c = str.length;
                }
                while (str.slice(c - 1, c) === '\\' && b < str.length) {
                    b++;
                    c = str.indexOf(q + ']', b);
                }
                parts.push(str.slice(i + 2, c).replace(new RegExp('\\' + q, 'g'), q));
                i = (str.slice(c + 2, c + 3) === '.') ? c + 3 : c + 2;
            }
        }
    }
    return parts;
}
exports.objectPath = objectPath;
function objectMissProps(propNames, obj) {
    var missingProps = [];
    for (var _i = 0, propNames_1 = propNames; _i < propNames_1.length; _i++) {
        var propName = propNames_1[_i];
        if (!obj.hasOwnProperty(propName)) {
            missingProps.push(propName);
        }
    }
    return missingProps.length ? missingProps : null;
}
exports.objectMissProps = objectMissProps;
function isNumeric(str) {
    return parseInt(str, 10).toString() === str;
}
exports.isNumeric = isNumeric;
function verifyRequiredProps(required, props, component) {
    var missingProps = objectMissProps(required, props);
    if (missingProps) {
        throw (new Error("You forgot to specify '" + missingProps.join(', ') + "' propert" + (missingProps.length > 1 ? 'ies' : 'y') + "\n\t\t\t\tfor <" + Object.getPrototypeOf(component).constructor.name + " name=\"" + component.props.name + "\" /> component."));
    }
}
exports.verifyRequiredProps = verifyRequiredProps;
function normalizeSchema(draftSchema) {
    return Object.keys(draftSchema).reduce(function (schema, fieldName) {
        var fieldDefinition = draftSchema[fieldName];
        var normalizedFieldDefinition;
        if (Array.isArray(fieldDefinition)) {
            // tslint:disable-next-line:max-line-length
            normalizedFieldDefinition = (fieldDefinition.length === 2) ? fieldDefinition : [fieldDefinition[0], ''];
        }
        else {
            normalizedFieldDefinition = [fieldDefinition, ''];
        }
        schema[fieldName] = normalizedFieldDefinition;
        return schema;
    }, {});
}
exports.normalizeSchema = normalizeSchema;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/reactive-mobx-form/lib/utils.js
// module id = 4
// module chunks = 0